<template>
  <div v-if="$ability.can('read', 'Farm')">
    <div v-if="loadingList">
      <AppSkeletonTable></AppSkeletonTable>
    </div>
    <div v-else>
      <DataTable
        :value="results"
        responsiveLayout="stack"
        :scrollable="$isLargeScreen.value"
      >
        <Column
          header="Nome"
          field="name"
          style="min-width: 120px"
          :sortable="true"
        >
        </Column>
        <Column
          header="Fazenda"
          field="farm.name"
          style="min-width: 120px"
          :sortable="true"
        >
          <template #body="{ data }">
            {{ data?.farm?.name || '-' }}
          </template>
        </Column>
        <Column header="Status" field="status" style="min-width: 120px">
          <template #body="{ data: { status } }">
            <AppStatusTag :status="status"></AppStatusTag>
          </template>
        </Column>
        <Column
          header="Total de Bovinos"
          field="stats.bovineCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Touros"
          field="stats.bullCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Bois"
          field="stats.oxCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Vacas"
          field="stats.cowCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Bezerros"
          field="stats.calfCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Bezerras"
          field="stats.heiferCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Ações"
          style="min-width: 100px"
          alignFrozen="right"
          :frozen="true"
        >
          <template #body="{ data: { id } }">
            <div>
              <AppRouterLink
                :to="{ name: 'lot.edit', params: { id } }"
                :permission="{ action: 'write', subject: 'FarmLot' }"
              >
                <Button
                  :disabled="!$ability.can('write', 'FarmLot')"
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-text p-button-secondary p-mr-1"
                ></Button>
              </AppRouterLink>
              <Button
                type="button"
                icon="pi pi-trash"
                class="p-button-text p-button-secondary"
                :disabled="!$ability.can('delete', 'FarmLot')"
                @click="showDeleteConfirm(results, id, 'name')"
              ></Button>
            </div>
          </template>
        </Column>
      </DataTable>
      <Paginator
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="changeListPage({ page: $event.page + 1 })"
      ></Paginator>
      <router-link
        :to="{ name: 'lot.create' }"
        style="text-decoration: none"
        v-if="$ability.can('write', 'FarmLot')"
      >
        <AppFloatButton icon="pi pi-plus" />
      </router-link>
      <AppModalDelete
        type="Lote/Piquete"
        :visible="deleteConfirm.visible"
        :item="deleteConfirm.item"
        @confirm="onDelete()"
        @cancel="hideDeleteConfirm()"
      ></AppModalDelete>
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { FarmLotApi } from '../../services/api';
import useApiList from '../../lib/useApiList';
import useDeleteConfirm from '../../lib/useDeleteConfirm';

export default {
  name: 'FarmLotList',
  setup() {
    return {
      ...useApiList(FarmLotApi, { include: '[stats]' }),
      ...useDeleteConfirm(),
    };
  },
  data() {
    return {
      filters: {},
    };
  },
  async created() {
    await this.fetchList();
    this.$emitter.on('topbar-search', ({ query }) => {
      this.searchList(query);
    });
  },
  methods: {
    onDelete() {
      this.deleteListItem(this.deleteConfirm.id);
      this.hideDeleteConfirm();
    },
  },
  beforeUnmount() {
    this.$emitter.off('topbar-search');
  },
};
</script>

<style>
</style>
